import React from 'react';

import { StaticQuery, graphql } from 'gatsby';

import get from 'lodash/get';
import findIndex from 'lodash/findIndex';

import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

const Banner = ({ classes, hide, text }) => {
  if (hide) return null;

  return (
    <Grid item xs={12}>
      <div className={classes.root}>
        <div
          className={classes.content}
          dangerouslySetInnerHTML={{ __html: text.html }}
        />
      </div>
    </Grid>
  );
};

const styles = theme => ({
  root: {
    border: '1px solid #6a27e8',
    display: 'flex',
    justifyContent: 'center',
    margin: 24,
    borderRadius: 5,
  },
  content: {
    fontFamily: 'Paytone One',
    '& a': { color: '#6a27e8' },
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
    },
    [theme.breakpoints.down('sm')]: {
      padding: 8,
    },
    [theme.breakpoints.down('sm')]: {
      padding: 12,
      textAlign: 'center',
    },
  },
});

const BannerWithStyles = withStyles(styles)(Banner);

const BannerQuery = ({ uid }) => (
  <StaticQuery
    query={graphql`
      query {
        allPrismicBanner {
          nodes {
            data {
              text {
                html
              }
              pages {
                page {
                  type
                  slug
                  lang
                  lang
                  uid
                  link_type
                  isBroken
                  document {
                    __typename
                    ... on PrismicPage {
                      id
                    }
                    __typename
                    ... on PrismicMetrics {
                      id
                    }
                  }
                  target
                  raw {
                    id
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={data => <BannerWithStyles {...generateBannerProps(uid, data)} />}
  />
);

const generateBannerProps = (uid, data) => {
  const { text, pages } = get(
    data,
    ['allPrismicBanner', 'nodes', 0, 'data'],
    {}
  );

  const pageIndex = findIndex(pages, { page: { uid } });

  if (pageIndex === -1) {
    return {
      hide: true,
    };
  }

  return { text };
};

export default BannerQuery;
